// eslint-disable-next-line import/no-extraneous-dependencies
// import $ from 'jquery'

const actions = {
  setearTitulo(texto) {
    $('#contenedor_identificativo').html(texto)
  },
  cargarArchivos(data, nombre_archivo, tipo_archivo) {
    const anchor_href = `${tipo_archivo},${data}`
    const exportLinkElement = document.createElement('a')
    exportLinkElement.hidden = true
    exportLinkElement.download = nombre_archivo
    exportLinkElement.href = anchor_href
    document.body.appendChild(exportLinkElement)
    exportLinkElement.click()
    exportLinkElement.remove()
  },
//   bloquearBoton() {
//     $('.btn-guardar').prop('disabled', true);
//     $('.btn-guardar span').html('<i class="icon-spinner4 text-size-base spinner"></i>&nbsp;Guardando...');
//   },
//   desbloquearBoton() {
//     $('.btn-guardar').prop('disabled', false);
//     $('.btn-guardar span').html(' Guardar');
//   },
}

export default actions
